import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import AllProducts from "./AllProducts/index";
import FilterSelect from "component/common/FilterSelect";
import { getCurrentInventory } from "service/Dashboard";
import { Toast } from "utils/toast";

import styles from "./CurrentInventory.module.scss";
import ChartLoader from "component/common/ChartLoader";

const CurrentInventory = () => {
  let [inventoryStats, setInventoryStats] = useState(null);

  let [inStock, setInStock] = useState({
    series: [],
    options: {
      chart: {
        type: "radialBar",
      },
      dataLabels: {
        show: false,
      },
      colors: ["#3C5877"],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "68%",
          },
          track: {
            show: true,
            background: ["#96C0FF"],
          },
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontFamily: undefined,
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: "18px",
              fontWeight: 600,
              color: "#151522",
              offsetY: -8,
              formatter: function (val) {
                return val + "%";
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: [""],
    },
  });

  let [purchased, setPurchased] = useState({
    series: [],
    options: {
      chart: {
        type: "radialBar",
      },
      dataLabels: {
        show: false,
      },
      colors: ["#3C5877"],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "68%",
          },
          track: {
            show: true,
            background: ["#96C0FF"],
          },
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontFamily: undefined,
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: "18px",
              fontWeight: 600,
              color: "#151522",
              offsetY: -8,
              formatter: function (val) {
                return val + "%";
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
      },

      labels: [""],
    },
  });

  let [returned, setReturned] = useState({
    series: [],
    options: {
      chart: {
        type: "radialBar",
      },
      dataLabels: {
        show: false,
      },
      colors: ["#3C5877"],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "68%",
          },
          track: {
            show: true,
            background: ["#96C0FF"],
          },
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontFamily: undefined,
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: "18px",
              fontWeight: 600,
              color: "#151522",
              offsetY: -8,
              formatter: function (val) {
                return val + "%";
              },
            },
          },
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: [""],
    },
  });

  let [loading, setLoading] = useState(true);

  let [year, setYear] = useState(2021);

  const yearOptions = [2021];

  useEffect(() => {
    setLoading(true);
    getInventory();
  }, [year]);

  const getInventory = async () => {
    try {
      let response = await getCurrentInventory({ year: year });
      if (response.status == 200) {
        let stockPercent = {
          ...inStock,
          series: [
            response.data.data.InStockPercentage
              ? response.data.data.InStockPercentage
              : 0,
          ],
        };
        let purchasePercent = {
          ...purchased,
          series: [
            response.data.data.purchasedPercentage
              ? response.data.data.purchasedPercentage
              : 0,
          ],
        };
        let retrunPercent = {
          ...returned,
          series: [
            response.data.data.RefundedPercentage
              ? response.data.data.RefundedPercentage
              : 0,
          ],
        };
        setInStock(stockPercent);
        setPurchased(purchasePercent);
        setReturned(retrunPercent);
        setInventoryStats(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <div className="col-md-6">
      <div className={styles.current_inventory_chart}>
        <div className={styles.current_inventory_title}>
          <b>Current Inventory</b>
          <div style={{ width: "100px" }}>
            <FilterSelect
              options={yearOptions}
              value={year}
              onChange={(e) => setYear(e.value)}
            />
          </div>
        </div>
        {loading ? (
          <ChartLoader />
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <AllProducts count={inventoryStats?.allProduct} />
            </div>
            <div className={styles.radical_chart}>
              <div className={styles.radical_chart_label}>
                <ReactApexChart
                  options={inStock.options}
                  series={inStock.series}
                  type="radialBar"
                  height={160}
                  width={120}
                />
                <b>In-Stock</b>
                <span>{inventoryStats?.InStock}</span>
              </div>
              <div className={styles.radical_chart_label}>
                <ReactApexChart
                  options={purchased.options}
                  series={purchased.series}
                  type="radialBar"
                  height={160}
                  width={120}
                />
                <b>Purchased</b>
                <span>{inventoryStats?.Purchased}</span>
              </div>
              <div className={styles.radical_chart_label}>
                <ReactApexChart
                  options={returned.options}
                  series={returned.series}
                  type="radialBar"
                  height={160}
                  width={120}
                />
                <b>Returned</b>
                <span>{inventoryStats?.Refunded}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CurrentInventory;
